import { IMonitoring } from '@/Models/IMonitoring';
import { ITypedValidationResult } from '@/Models/IValidationResult';
import { BaseApiService } from './base-api-service';

class monitoringService extends BaseApiService {
    public constructor() {
		super('monitoring/');
    }

	public async getByPhaseId(phaseId: number): Promise<IMonitoring[]> {
		return this.httpClient.get<IMonitoring[]>(`GetByPhaseId/${phaseId}`).then(this.handleResponse.bind(this)).catch(this.handleError.bind(this));
    }
    
	public async save(dto: IMonitoring): Promise<ITypedValidationResult<IMonitoring>> {
		return this.httpClient.post<ITypedValidationResult<IMonitoring>>("save", dto).then(this.handleResponse.bind(this)).catch(this.handleError.bind(this));
	}

	public async delete(id: number): Promise<void> {
		return this.httpClient.delete<void>(`delete/${id}`).then(this.handleResponse.bind(this)).catch(this.handleError.bind(this));
	}
}

export const MonitoringService: monitoringService = new monitoringService();